import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import Logo from "../../general/Logo";
import UsersModal from "./../../general/UsersModal";
import MemorialModal from "../../general/MemorialModal";
import CorrecoesModal from "../../general/CorrecoesModal";
import { useResponsive } from "../../../hooks/useResponsive";
import UserIcon from "../../general/UserIcon";

const itemStyle = {
  display: "block",
  width: "100%",
  background: "none",
  border: "none",
  textAlign: "left",
  padding: "12px 18px",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 14,
  fontWeight: 500,
  color: "#2d2d2d",
  cursor: "pointer",
};

function Header({ onLogin, onHome, user, onLogout, navigate, onFalecidoUpdated }) {
  const { isMobile } = useResponsive();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openUsersModal, setOpenUsersModal] = useState(false);
  const [openMemorialModal, setOpenMemorialModal] = useState(false);
  const [openCorrecoesModal, setOpenCorrecoesModal] = useState(false);

  const dropdownRef = useRef(null);
  const userMenuRef = useRef(null);

  const isAdmin = user && (user.username  === "Serviços Urbanos - ADM" || user.username === "Igor Maciel" || user.username === "JhonataCCP" || user.username === "Administrador" || user.username === "admin");

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Close mobile menu on resize to desktop
  useEffect(() => {
    if (!isMobile) setMobileMenuOpen(false);
  }, [isMobile]);

  const btnStyle = {
    background: "rgba(255,255,255,0.2)",
    border: "1.5px solid #fff",
    color: "#fff",
    borderRadius: 8,
    padding: "6px 18px",
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    fontWeight: 600,
  };

  const cadastrarItems = [
    { label: "Óbito e sepultamento", page: "register-burial" },
    { label: "Usuários do sistema", page: "register" },
  ];

  return (
    <>
      <header
        style={{
          background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          height: 62,
          position: "sticky",
          top: 0,
          zIndex: 200,
        }}
      >
        {/* LEFT */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            onClick={onHome}
            style={{
              background: "#fff",
              borderRadius: "0 0 16px 0",
              padding: "0 28px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              height: 60,
            }}
          >
            <Logo />
          </div>

          {/* Desktop only: Cadastrar dropdown */}
          {!isMobile && user && navigate && (
            <div
              ref={dropdownRef}
              style={{ position: "relative", marginLeft: 16 }}
            >
              <button
                onClick={() => setDropdownOpen((o) => !o)}
                style={{
                  ...btnStyle,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                Cadastrar
                <svg width="12" height="12" viewBox="0 0 12 12">
                  <path
                    d="M2 4l4 4 4-4"
                    stroke="#fff"
                    strokeWidth="1.8"
                    fill="none"
                  />
                </svg>
              </button>

              {dropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "calc(100% + 6px)",
                    left: 0,
                    background: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                    minWidth: 180,
                    overflow: "hidden",
                    zIndex: 100,
                  }}
                >
                  {cadastrarItems.map((item) => (
                    <button
                      key={item.page}
                      onClick={() => {
                        setDropdownOpen(false);
                        navigate(item.page);
                      }}
                      style={itemStyle}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#FFF3EB")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "none")
                      }
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* RIGHT */}
        {isMobile ? (
          /* Mobile: hamburger or login */
          user ? (
            <button
              onClick={() => setMobileMenuOpen((o) => !o)}
              style={{
                background: "none",
                border: "none",
                padding: "0 20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                <line
                  x1="3" y1="6" x2="23" y2="6"
                  stroke="#fff" strokeWidth="2.5" strokeLinecap="round"
                />
                <line
                  x1="3" y1="13" x2="23" y2="13"
                  stroke="#fff" strokeWidth="2.5" strokeLinecap="round"
                />
                <line
                  x1="3" y1="20" x2="23" y2="20"
                  stroke="#fff" strokeWidth="2.5" strokeLinecap="round"
                />
              </svg>
            </button>
          ) : (
            <button
              onClick={onLogin}
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 16,
                fontWeight: 600,
                padding: "0 20px",
              }}
            >
              Login
            </button>
          )
        ) : /* Desktop: user info + Menu dropdown */
        user ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "0 32px",
            }}
          >
            <UserIcon />

            <span
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 16,
                fontWeight: 600,
                color: "#fff",
              }}
            >
              {user.name}
            </span>

            <div ref={userMenuRef} style={{ position: "relative" }}>
              <button
                onClick={() => setUserMenuOpen((o) => !o)}
                style={{
                  ...btnStyle,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                Menu
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 4l4 4 4-4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {userMenuOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "calc(100% + 6px)",
                    right: 0,
                    background: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                    minWidth: 200,
                    overflow: "hidden",
                    zIndex: 9999,
                  }}
                >
                  {user && isAdmin && (
                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        setOpenUsersModal(true);
                      }}
                    style={itemStyle}
                  >
                    Listar usuários
                  </button>
                  )}

                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        setOpenMemorialModal(true);
                      }}
                      style={itemStyle}
                    >
                      Avaliação de mensagens
                    </button>

                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        setOpenCorrecoesModal(true);
                      }}
                      style={itemStyle}
                    >
                      Solicitações de correção
                    </button>

                  <hr />

                  <button
                    onClick={() => {
                      setUserMenuOpen(false);
                      onLogout();
                    }}
                    style={{ ...itemStyle, color: "red" }}
                  >
                    Sair
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <button
            onClick={onLogin}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 18,
              fontWeight: 600,
              padding: "0 32px",
            }}
          >
            <UserIcon />
            Login
          </button>
        )}

        {openUsersModal &&
          createPortal(
            <UsersModal
              isOpen={openUsersModal}
              onClose={() => setOpenUsersModal(false)}
            />,
            document.body,
          )}

        {openMemorialModal &&
          createPortal(
            <MemorialModal
              isOpen={openMemorialModal}
              onClose={() => setOpenMemorialModal(false)}
            />,
            document.body,
          )}

        {openCorrecoesModal &&
          createPortal(
            <CorrecoesModal
              isOpen={openCorrecoesModal}
              onClose={() => setOpenCorrecoesModal(false)}
              onFalecidoUpdated={onFalecidoUpdated}
            />,
            document.body,
          )}
      </header>

      {/* Mobile dropdown menu via portal */}
      {isMobile &&
        mobileMenuOpen &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: 62,
              left: 0,
              width: "100%",
              height: "calc(100vh - 62px)",
              zIndex: 199,
            }}
            onClick={() => setMobileMenuOpen(false)}
          >
            <div
              style={{
                background: "#fff",
                boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
                borderRadius: "0 0 12px 12px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {user && (
                <div
                  style={{
                    padding: "14px 20px 10px",
                    borderBottom: "1px solid #f0f0f0",
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 13,
                    color: "#888",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <UserIcon size={20} />
                  {user.name}
                </div>
              )}

              {user && navigate && (
                <>
                  <div
                    style={{
                      padding: "8px 18px 4px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#E8956A",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                  >
                    Cadastrar
                  </div>
                  {cadastrarItems.map((item) => (
                    <button
                      key={item.page}
                      onClick={() => {
                        setMobileMenuOpen(false);
                        navigate(item.page);
                      }}
                      style={{ ...itemStyle, paddingLeft: 28 }}
                    >
                      {item.label}
                    </button>
                  ))}

                  <hr
                    style={{
                      margin: "4px 0",
                      border: "none",
                      borderTop: "1px solid #f0f0f0",
                    }}
                  />

                  <div
                    style={{
                      padding: "8px 18px 4px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#E8956A",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                  >
                    Administração
                  </div>

                  <button
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setOpenUsersModal(true);
                    }}
                    style={{ ...itemStyle, paddingLeft: 28 }}
                  >
                    Listar usuários
                  </button>
                  <button
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setOpenMemorialModal(true);
                    }}
                    style={{ ...itemStyle, paddingLeft: 28 }}
                  >
                    Avaliação de mensagens
                  </button>
                  <button
                    onClick={() => { setMobileMenuOpen(false); setOpenCorrecoesModal(true); }}
                    style={{ ...itemStyle, paddingLeft: 28 }}
                  >
                    Solicitações de correção
                  </button>
                  <hr
                    style={{
                      margin: "4px 0",
                      border: "none",
                      borderTop: "1px solid #f0f0f0",
                    }}
                  />

                  <button
                    onClick={() => {
                      setMobileMenuOpen(false);
                      onLogout();
                    }}
                    style={{ ...itemStyle, color: "red", paddingBottom: 16 }}
                  >
                    Sair
                  </button>
                </>
              )}
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}

export default Header;
